<script>
import { authComputed } from "@/store/helpers";
import BlotFormatter from "quill-blot-formatter";
import { ref } from "vue";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import { mapActions } from "vuex";

export default {
    props: {
        paragraphObj: Object,
    },
    computed: {
        ...authComputed,
    },
    name: "EditParagraph",
    components: { QuillEditor },

    data() {
        return {
            paragraphTitle: "",
            paragraphText: "",
        };
    },

    watch: {
        paragraphObj: {
            handler(newParagraphObj) {
                // Set paragraphTitle and paragraphText when paragraphObj changes
                this.paragraphTitle = newParagraphObj.paragraphTitle;
                this.paragraphText = newParagraphObj.paragraphText;
            },
            immediate: true, // Trigger the handler immediately on component creation
        },
    },

    inject: ["GStore"],

    setup: () => {
        const modules = {
            name: "blotFormatter",
            module: BlotFormatter,
            options: {
                /* options */
            },
        };

        const content = ref("");
        const { getParagraphs } = mapActions(["getParagraphs"]);
        return { modules, getParagraphs, content };
    },

    methods: {
        ...mapActions(["getParagraphs"]),

        async deleteParagraph(item) {
            // Ask for user confirmation
            if (window.confirm("Are you sure you want to delete this paragraph ?")) {
                try {
                    await this.$store.dispatch("deleteParagraph", {
                        id: this.paragraphObj.id,
                    });
                    this.GStore.flashMessage = "Deleted successfully";

                    setTimeout(() => {
                        this.GStore.flashMessage = "";
                    }, 3000);

                } catch (error) {
                    this.GStore.flashMessage = "Something went wrong";
                    setTimeout(() => {
                        this.GStore.flashMessage = "";
                    }, 3000);
                }
            }
        },

        async updateParagraph() {
            this.$store
                .dispatch("updateParagraph", {
                    id: this.paragraphObj.id,
                    paragraphTitle: this.paragraphTitle,
                    paragraphText: this.paragraphText,
                })
                .then(() => {
                    this.GStore.flashMessage =
                        "The paragraph has been modified successfully!";
                    setTimeout(() => {
                        this.GStore.flashMessage = "";
                    }, 3000);
                })
                .catch(() => {
                    this.GStore.flashMessage =
                        "An unknown error occurred. Please try again later! ";
                    setTimeout(() => {
                        this.GStore.flashMessage = "";
                    }, 3000);
                });
        },
    },
};
</script>

<template>
    <div class="row">
        <h1 class="vrm-page-title">Edit paragraph</h1>
        <br />
        <!-- <form @submit.prevent="updateParagraph"> -->
        <fieldset class="fieldset">
            <div class="fieldset__item">
                <input v-model="paragraphTitle" name="paragraphTitle" class="sg-element" type="text" value />
            </div>
        </fieldset>
        <QuillEditor ref="quillRef" class="sg-required" v-model:content="paragraphText" content-type="html"
            toolbar="#my-toolbar">
            <template #toolbar>
                <div id="my-toolbar">
                    <select class="ql-size">
                        <option value="small"></option>
                        <option selected></option>
                        <option value="large"></option>
                        <option value="huge"></option>
                    </select>

                    <select class="ql-header">
                        <option :value="1"></option>
                        <option :value="2"></option>
                        <option :value="3"></option>
                        <option :value="4"></option>
                        <option :value="5"></option>
                        <option :value="6"></option>
                    </select>
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                    <button class="ql-strike"></button>
                    <button class="ql-script" value="sub"></button>
                    <button class="ql-script" value="super"></button>
                    <select class="ql-align">
                        <option value="center"></option>
                        <option value="right"></option>
                        <option value="justify"></option>
                    </select>
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <button class="ql-blockquote"></button>
                    <button class="ql-link"></button>
                    <!-- <button class="button" @click="deleteParagraph(paragraphObj)">Delete</button> -->

                </div>
            </template>
        </QuillEditor>

        <div class="vrm-panel--form__button-container" v-if="this.paragraphText.length > 15 && this.paragraphTitle">
            <button class="sg-btn sg-blue sg-element" @click="updateParagraph()" name="buttonAddParagraph">
                Save modifications
            </button>

            <button class="sg-btn sg-blue sg-element" @click="deleteParagraph(paragraphObj)">
                Delete paragraph
            </button>
            <div class="flashMessage" v-if="GStore.flashMessage">
                {{ GStore.flashMessage }}
            </div>
        </div>
        <!-- </form> -->
    </div>
</template>

<style scoped lang="less"></style>
